import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export const friendAbilitiesUrl = '/api/citizen/v1/pet/ability';

export type BoostDetail = {
  growth: string;
  boost: number;
  holdingNum: number;
};
export type FriendAbility = {
  totalBoost: number;
  maxBoost: number;
  boostDetail: BoostDetail[];
};

export const getFriendAbilities = async () => {
  const { data } = await axios.get<FriendAbility>(friendAbilitiesUrl);
  return data;
};

export const useFriendAbilities = (options?: UseDosiminQueryOptions<FriendAbility>) =>
  useQuery<FriendAbility>(['friend', 'ability'], getFriendAbilities, {
    initialData: {
      totalBoost: 0,
      maxBoost: 0,
      boostDetail: [],
    },
    ...options,
  });
